import React, { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import {
	BrandUtil,
	EmotionBreakpoint,
	usePageLayer,
	wineryDirectStates,
} from 'dw-us-ui';

const Layout = styled.div`
	display: flex;
	height: 1009px;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	${EmotionBreakpoint('mobile')} {
		gap: 20px;
	}
	${EmotionBreakpoint('tablet')} {
		gap: 20px;
	}
`;
const Headline = styled.h2`
	color: ${(props) => (props.headlineColor ? props.headlineColor : '#cf004f')};
	text-align: center;
	font-family: ${(props) =>
			props.headlineFont ? props.headlineFont : 'Oswald'},
		sans-serif;
	font-size: 48px;
	font-style: normal;
	font-weight: 500;
	line-height: 45.6px;
	letter-spacing: -0.48px;
	${EmotionBreakpoint('mobile')} {
		font-size: 30px;
	}
	${EmotionBreakpoint('tablet')} {
		font-size: 30px;
	}
`;

const CompareCardSubscriptions = styled.div`
	display: flex;
	height: 900px;
	align-items: flex-start;
	gap: 21px;
	flex-shrink: 0;

	@media (max-width: 1024px) {
		width: 100%;
		padding-left: 4%;
	}

	${EmotionBreakpoint('tablet')} {
		padding-left: 0;
	}

	hr {
		width: 286px;
		border: none;
		height: 1px;
		background-color: ${(props) =>
			props.hrbackgroundcolor ? props.hrbackgroundcolor : '#9a7f6b;'};
		margin: 0 !important;
		${EmotionBreakpoint('tablet')} {
			width: 200px;
		}
	}
	${EmotionBreakpoint('mobile')} {
		overflow-x: auto;
		scroll-snap-type: x mandatory;
		gap: 0px;
		&::-webkit-scrollbar {
			display: none;
		}
		> div {
			scroll-snap-align: start;
			flex-shrink: 0;
			scroll-behavior: smooth;
		}
	}
	${EmotionBreakpoint('tablet')} {
		gap: 15px;
	}
`;

const CompareCard = styled.div`
	display: flex;
	width: 358px;
	height: 900px;
	flex-direction: column;
	align-items: center;
	gap: 31px;
	flex-shrink: 0;
	border: 2px solid
		${(props) =>
			props.imageBorderColor ? props.imageBorderColor : 'rgba(0, 0, 0, 0)'};

	@media (max-width: 1024px) {
		width: 100%;
	}

	${EmotionBreakpoint('mobile')} {
		gap: 30px;
		width: 95%;
		display: ${(props) => (props.isActive ? 'flex' : 'none')};
	}

	${EmotionBreakpoint('tablet')} {
		width: 230px;
	}
`;
const CardImage = styled.div`
	img {
		width: 354px;
		height: 221px;
		flex-shrink: 0;

		@media (max-width: 1024px) {
			width: 100%;
		}

		${EmotionBreakpoint('mobile')} {
			width: 100%;
		}
	}

	${EmotionBreakpoint('tablet')} {
		img {
			width: 226px;
		}
	}
`;
const CardNamePlate = styled.div`
	color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
	border-radius: 40px;
	border: 1px solid
		${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
	display: inline-flex;
	padding: 5px 26px;
	align-items: center;
	gap: 10px;
	font-family: 'Open Sans', sans-serif;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	background: #fff;
	margin-top: -42px;
	${EmotionBreakpoint('mobile')} {
		padding: 4px 11px 4px 11px;
		margin-top: -40px;
	}
	${EmotionBreakpoint('tablet')} {
		padding: 4px 11px 4px 11px;
		margin-top: -40px;
	}
`;
const BrothersCollectionContainer = styled.div`
	display: flex;
	width: 300px;
	padding-top: 5px;
	flex-direction: column;
	align-items: center;
	gap: 20px;

	${EmotionBreakpoint('mobile')} {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
	}
	${EmotionBreakpoint('tablet')} {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
	}
`;
const BrothersName = styled.h6`
	color: ${(props) => (props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)')};
	text-align: center;
	font-family: 'Open Sans', sans-serif;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 18.4px;
	text-transform: uppercase;
`;
const BrothersCollection = styled.div`
	${EmotionBreakpoint('tablet')} {
		img {

			width: 136px;
   			sheight: 82px;
		}
`;
const BrosBlurbText = styled.div`
	color: #222;
	text-align: center;
	font-family: Arial, sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 18px;
	letter-spacing: 0.9px;
	text-wrap: balance;
	${EmotionBreakpoint('tablet')} {
		font-size: 10px;
	}
	.law & {
		font-family: 'Open Sans', sans-serif;
	}
`;
const BrosBenefits = styled.div`
	display: flex;
	width: 300px;
	height: 244px;
	flex-direction: column;
	align-items: flex-start;
	gap: 15px;
	text-align: left;
	padding-left: 30px;
	ul.signature-collection-compare {
		list-style-type: disc;
		color: #000;
		font-family: 'Open Sans', sans-serif;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 22.4px;
		text-align: left;
		${EmotionBreakpoint('tablet')} {
			font-size: 12px;
		}
	}
	li {
		margin-bottom: 15px;
	}
	li::marker {
		font-size: 0.5em;
	}
	${EmotionBreakpoint('mobile')} {
	}
	${EmotionBreakpoint('tablet')} {
		width: 251px;
	}
`;
const BrosCompareButton = styled.a`
	display: flex;
	width: 289px;
	padding: 15px 25px 14px 25px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	cursor: pointer;
	font-family: ${(props) =>
			props.membershipPerksEyebrowFont
				? props.membershipPerksEyebrowFont
				: 'Open Sans'},
		sans-serif;
	text-align: center;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 14px;
	letter-spacing: 0.75px;
	text-transform: uppercase;
	border: none;
	margin: auto;
	text-decoration: none !important;
	background: ${(props) =>
		props.cardColor ? props.cardColor : 'rgba(0, 0, 0, 0)'};

	a {
		color: #fff !important;
		text-decoration: none;
	}

	@media (max-width: 1024px) {
		width: 90%;
	}

	${EmotionBreakpoint('tablet')} {
		width: 204px;
		height: 34px;
	}
`;

const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 31px;
	width: 100%;
	height: 100%;

	@media (max-width: 1024px) {
		width: ${(props) => `calc(${Math.round(props.elementWidth / 10) * 10}%)`};
	}

	${EmotionBreakpoint('tablet')} {
		width: 100%;
	}

	${EmotionBreakpoint('mobile')} {
		display: flex;
		width: 100%;
	}
`;

const PaginationTopLeft = styled.div`
		visibility: hidden;
	${EmotionBreakpoint('mobile')} {
		 visibility: visible;
		position: relative;
		top: 6px;
		right: 154px;
		background-color: transparent;
		color: #2B2A2;
		font-size: 17px;
		font-style: normal;
		font-weight: 400;
		line-height: 130%
		padding: 5px 10px;
		font-family:${(props) =>
			props.membershipPerksHeadlineFont
				? props.membershipPerksHeadlineFont
				: 'Noto Serif'};
	}
`;

const Pagination = styled.ul`
	display: none;
	list-style: none;
	${EmotionBreakpoint('mobile')} {
		display: flex;
		padding: 0;
		justify-content: center;

		li {
			width: 10px;
			height: 10px;
			background-color: #ccc;
			border-radius: 50%;
			margin: 0 5px;
			cursor: pointer;
		}
		.active {
			background-color: #055faf;
		}
	}
`;

const CompareCards = ({ contentfulData }) => {
	const numberOfCards = contentfulData?.compareCards?.length || 0;
	const [activeCardIndex, setActiveCardIndex] = useState(0);
	const scrollContainerRef = useRef(null);
	const pageLayer = usePageLayer();

	const handleScroll = (e) => {
		const scrollLeft = e.target.scrollLeft;
		const cardWidth = e.target.firstChild.offsetWidth;
		const newIndex = Math.round(scrollLeft / (cardWidth + 21));
		setActiveCardIndex(newIndex);
	};

	return (
		<Layout>
			<Headline
				id='BrothersCollection'
				headlineColor={contentfulData?.headlineColor}
				headlineFont={contentfulData?.headlineFont}
			>
				{contentfulData?.compareCardsEyebrow}
			</Headline>

			<PaginationTopLeft
				membershipPerksHeadlineFont={
					contentfulData?.membershipPerksHeadlineFont
				}
			>
				<span>{`${String(activeCardIndex + 1).padStart(2, '0')} / ${String(
					numberOfCards
				).padStart(2, '0')}`}</span>
			</PaginationTopLeft>

			<CompareCardSubscriptions
				ref={scrollContainerRef}
				onScroll={handleScroll}
				hrbackgroundcolor={contentfulData?.faqHrLineColor}
			>
				{contentfulData?.compareCards?.map((card, index) => (
					<CardContainer
						key={index}
						elementWidth={100 / contentfulData.compareCards.length}
					>
						<CompareCard
							cardColor={card?.fields?.cardColor}
							imageBorderColor={card?.fields?.imageBorderColor}
							isActive={index === activeCardIndex}
						>
							<CardImage>
								<img src={card?.fields?.cardImage?.fields?.file?.url} />
							</CardImage>
							{card?.fields?.namePlate?.content[0]?.content[0]?.value && (
								<CardNamePlate cardColor={card?.fields?.cardColor}>
									{card?.fields?.namePlate?.content[0].content[0].value}
								</CardNamePlate>
							)}
							<BrothersCollectionContainer>
								{card?.fields?.textCardHeadline?.content[0]?.content[0]
									?.value && (
									<BrothersName cardColor={card?.fields?.cardColor}>
										{
											card?.fields?.textCardHeadline?.content[0]?.content[0]
												?.value
										}
									</BrothersName>
								)}
								{card?.fields?.subscriptionOverviewImage?.fields?.file?.url && (
									<BrothersCollection>
										<img
											src={
												card?.fields?.subscriptionOverviewImage?.fields?.file
													?.url
											}
										/>
									</BrothersCollection>
								)}
							</BrothersCollectionContainer>

							<BrosBlurbText>{card?.fields?.textBlock}</BrosBlurbText>
							<hr />
							<BrosBenefits
								dangerouslySetInnerHTML={{
									__html: card.fields.benefitText[0].fields.htmlContent,
								}}
							></BrosBenefits>
							<BrosCompareButton
								membershipPerksEyebrowFont={
									contentfulData?.membershipPerksEyebrowFont
								}
								role='button'
								cardColor={card?.fields?.cardColor}
								href={
									wineryDirectStates.includes(pageLayer?.stateCode)
										? card?.fields?.wineryDirectLink
										: card?.fields?.threeTierLink
								}
							>
								<a
									href={
										wineryDirectStates.includes(pageLayer?.stateCode)
											? card?.fields?.wineryDirectLink
											: card?.fields?.threeTierLink
									}
								>
									{card?.fields?.buttonCopy}
								</a>
							</BrosCompareButton>
						</CompareCard>
					</CardContainer>
				))}
			</CompareCardSubscriptions>

			<Pagination>
				{Array.from({ length: numberOfCards }).map((_, index) => (
					<li
						key={index}
						className={index === activeCardIndex ? 'active' : ''}
					></li>
				))}
			</Pagination>
		</Layout>
	);
};

export default CompareCards;
